import { h } from "vue";

import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { type DomainInTree } from "@/stores/domains-store";
import { EntityType } from "@/stores/entity-store";
import { vnodeToHtml } from "@/utils";

import { createEntityExtension } from "../mystekz-linked-entities";
import { LinkedEntity } from "../mystekz-linked-entities";
import { DomainsManager } from "./manager";

export type DomainEntity = LinkedEntity<"domain", DomainInTree>;

let domainsManager: DomainsManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getDomainesManager = (baseUrl: string) => {
    if (!domainsManager) {
        domainsManager = new DomainsManager(baseUrl);
    }
    return domainsManager;
};

export const DomainsExtension = createEntityExtension(
    "domain",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "domainDetails",
            hover: true,
            create: (_: Promise<DomainEntity | void>, entityId: string) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.DOMAIN,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "domainInsert",
        },
    },
    getDomainesManager,
    {
        label: "References",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "pi-cloud",
            library: "primeicons",
        },
        group: "Linked Domain Objects",
    }
);
